module.exports = __webpack_public_path__ + "img/茂名市市场监督管理局.fe981ac7.png";